import type { Router } from 'vue-router';

import { RouterPages } from '@/shared/router';

type RouterErrorHandler = (error: Error) => Promise<void>;

const createRouterErrorHandler = (router: Router): RouterErrorHandler => {
  let isRedirectingToError: boolean = false;

  return async (error: Error): Promise<void> => {
    void error;

    if (isRedirectingToError || router.currentRoute.value.name === RouterPages.ERROR) {
      return;
    }

    isRedirectingToError = true;

    try {
      await router.replace({ name: RouterPages.ERROR });
    } finally {
      isRedirectingToError = false;
    }
  };
};

export { createRouterErrorHandler };
